import { FieldValue, fieldControlClass, fieldDescribedBy } from "./FieldValue";
import { LongTextFieldProps } from "./LongTextField.types";

/** Long text (`text`/`ntext`/`textarea`) editable field. */
export function LongTextField({
  label,
  name,
  value,
  onChange,
  disabled,
  required,
  rows = 3,
  error,
  className,
  placeholder,
  helpText,
}: LongTextFieldProps) {
  return (
    <FieldValue label={label} htmlFor={name} required={required} helpText={helpText} error={error} className={className}>
      <textarea
        id={name}
        aria-describedby={fieldDescribedBy(name, helpText, error)}
        aria-invalid={error ? true : undefined}
        name={name}
        className={fieldControlClass("form-control", error)}
        value={value ?? ""}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        rows={rows}
      />
    </FieldValue>
  );
}
